import { useSendMailHistory } from '../../Providers/SendMailHistoryProvider';
import StackVertical from '../../Framework/Components/Wrappers/StackVertical';
import { FlexAlign, FlexGap, FlexJustify } from '../../Framework/Data/Enums/LayoutEnums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBomb, faEnvelope, faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { SendsHistoryEntryType } from '../../Api/StandaloneSendsEndpoints';
import React from 'react';
import { formatLocaleRelative } from '../../Framework/Constants/DateHelpers';
import { NavLink } from 'react-router-dom';
import { useLayout } from '../../Framework/Providers/LayoutProvider';
import { SendsItemTrackingLink } from './SendsHistoryItem';

const StandaloneSendsHistoryOverview = () => {
	const { status, data, error } = useSendMailHistory();
	const { isTiny, isSmall, isLarge } = useLayout();

	return (
		<>
			<div className={'history-mini-heading'}>
				<h6 className={'sub-heading pageantry-sub-heading m-0'}>Previous Sends</h6>
			</div>
			{status === 'loading' ? (
				<div className={'content-loader content-fader'}>
					<div style={{ height: '6.2em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
					<div style={{ height: '6.2em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
					<div style={{ height: '6.2em', marginInline: !isLarge ? 'var(--md-negative-unit)' : '0' }} />
				</div>
			) : status === 'error' ? (
				<StackVertical
					gap={FlexGap.ExtraSmall}
					align={FlexAlign.Center}
					justify={FlexJustify.Center}
					extraClass={'m-xxl p-xxl text-center'}
				>
					<FontAwesomeIcon icon={faBomb} size={'3x'} />
					<h6 className={'sub-heading mt-sm mb-xs'}>History</h6>
					<p>{error.message}</p>
				</StackVertical>
			) : (
				<>
					{data &&
						data.pages.map((group: any, groupIndex: number) =>
							group.data.map((entry: SendsHistoryEntryType, index: number) => {
								if (index < 3) {
									return (
										<a
											key={`historyOverviewItem${entry.id}`}
											className={'page-list-nav-item history-mini-entry'}
											href={`${process.env.REACT_APP_CLIENT_HOST}/Mail#/mail/${entry.mailItem.trackingId}`}
											target={'_parent'}
										>
											<div className={'history-primary'}>
												<div>{entry.mailItem.trackingId}</div>
												<div className={'text-right ml-a'}>
													{formatLocaleRelative(entry.dateCreated)}
												</div>
											</div>
											<div className={'history-secondary'}>
												<FontAwesomeIcon
													icon={faLocationDot}
													fixedWidth={true}
													className={'mr-xs'}
												/>
												{entry.address.addressId === 0
													? entry.address.name
													: entry.address.formatted}
											</div>
											<div className={'history-secondary'}>
												<FontAwesomeIcon
													icon={faEnvelope}
													fixedWidth={true}
													className={'mr-xs'}
												/>
												{entry.postageOption.name}

												{entry.mailItem.outgoingTrackingId && (
													<SendsItemTrackingLink
														trackingId={entry.mailItem.outgoingTrackingId}
														postageName={entry.postageOption.name}
													/>
												)}
											</div>
										</a>
									);
								}
							})
						)}
					<div className={isTiny || isSmall ? 'm-sm' : 'mt-sm'}>
						<NavLink className={`btn btn-block btn-small `} to={'../sends-page/history'}>
							View All
						</NavLink>
					</div>
				</>
			)}
		</>
	);
};

export { StandaloneSendsHistoryOverview };
